import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

const SuspenseLoader = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 10000,
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: 'auto',
        marginBottom: 'auto',
      }}
    >
      <div className="card flex justify-content-center">
        <ProgressSpinner />
      </div>
    </div>
  );
};

export default SuspenseLoader;
